import { mapToIds } from "."

const useReportUtils = () => {
  const getNavigateToLink = (area, days, locations, groups) =>
    `/reports/${area}/${days}/${mapToIds(locations).join("-")}/${mapToIds(groups).join("-")}`

  const getNavigateToJobsLink = (days, locations, groups, process) =>
    `${getNavigateToLink("jobs", days, locations, groups)}/${process}`

  const getNavigateToPeopleLink = (days, locations, groups, user) =>
    `${getNavigateToLink("people", days, locations, groups)}${user ? `/${user}` : ""}`

  const filterChange = (prev, event) => {
    const targetValues = event.target.value
    if (prev.includes("all") && targetValues.length > 1) {
      return targetValues.filter((targetValue) => targetValue !== "all")
    }
    if ((!prev.includes("all") && targetValues.includes("all")) || !targetValues.length) {
      return ["all"]
    }
    return targetValues
  }

  return {
    getNavigateToLink,
    getNavigateToJobsLink,
    getNavigateToPeopleLink,

    filterChange,
  }
}

export { useReportUtils }
